export const UPGRADE_MODAL_COPY = {
  agent_identity: {
    title: 'Dê a cara da sua marca ao seu atendente',
    description:
      'Visitantes compram de quem confiam. Personalize o nome e a mensagem inicial para acolher cada cliente nos primeiros segundos e transformar dúvidas em carrinhos pagos.',
  },
  agent_branding: {
    title: 'Deixe o chat 100% alinhado às cores da sua loja',
    description:
      'No e-commerce, identidade visual é sinônimo de segurança. Um chat harmonizado com sua marca elimina a sensação de "plugin de fora" e aumenta a confiança na hora de fechar o pedido.',
  },
  ai_instructions: {
    title: 'Ensine sua IA a vender como seu melhor atendente',
    description:
      'Treine o agente com as regras da sua loja: frete grátis, cupons, trocas e recomendações de produtos. Ele tira as dúvidas que travam a compra e fecha vendas 24h por dia para você.',
  },
  publish_store: {
    title: 'Coloque seu vendedor de IA para rodar na sua loja hoje',
    description:
      'Seu agente já está configurado e pronto para atender. Ative seu plano agora para colocá-lo no ar em 1 minuto e comece a recuperar vendas de visitantes que sairiam sem comprar.',
  },
  team_quota: {
    title: 'Traga toda a sua equipe para acelerar o atendimento',
    description:
      'Dê acessos individuais aos seus atendentes e sócios com segurança, sem compartilhar senhas. Organize seu time, responda mais rápido e escale sua operação sem gargalos.',
  },
  usage_quota: {
    title: 'Não deixe seus clientes sem resposta na loja',
    description:
      'Você atingiu o limite de conversas do seu plano e novos visitantes podem ficar sem atendimento. Faça o upgrade agora para manter seu agente ativo e não perder nenhuma venda em andamento.',
  },
  default: {
    title: 'Desbloqueie todo o potencial de vendas da sua loja',
    description:
      'Atenda instantaneamente, tire dúvidas de frete e recupere carrinhos 24 horas por dia. Escolha o plano ideal e veja seu agente de IA se pagar logo nas primeiras vendas salvas.',
  },
} as const;
